/* @flow */

import deburr from 'lodash/deburr';

const escapeRegExp = (text: string) => text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

const execDynamicRegExp = (agulha: string, palheiro: string) => (
    (new RegExp(escapeRegExp(deburr(agulha)), 'gi')).exec(deburr(palheiro))
);

export default execDynamicRegExp;
